import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Hourglass, ChevronRight, Check } from "lucide-react";
import { api } from "@/lib/api";

export default function NfaStalledAlert() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    api.get("/budgets/nfa-stalled").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);
  const ack = async (id) => {
    setBusy(id);
    try {
      await api.post(`/budgets/${id}/nfa-stalled/ack`);
      setItems((l) => l.filter((x) => x.id !== id));
      toast.success("Ciente — a contagem de 7 dias recomeçou");
    } catch { toast.error("Não foi possível registrar"); } finally { setBusy(null); }
  };
  if (!items.length) return null;
  return (
    <div className="bg-indigo-50 border-2 border-indigo-200 rounded-2xl p-4 card-shadow" data-testid="nfa-stalled-alert">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-indigo-600 text-white flex items-center justify-center shrink-0">
          <Hourglass className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-heading text-sm md:text-base font-black text-indigo-900">
            {items.length} orçamento{items.length > 1 ? "s" : ""} com nota emitida parado{items.length > 1 ? "s" : ""} há 7+ dias
          </p>
          <p className="text-[12px] text-indigo-800/80 mt-0.5">Nenhum item foi concluído recentemente. Retome a execução.</p>
          <ul className="mt-2 space-y-1.5">
            {items.map((s) => (
              <li key={s.id} className="flex items-stretch gap-1.5">
                <Link
                  to={`/orcamentos/${s.id}`}
                  className="flex-1 min-w-0 flex items-center justify-between gap-2 bg-white rounded-lg border border-indigo-100 px-3 py-2 hover:bg-indigo-50 transition-colors"
                  data-testid={`nfa-stalled-${s.id}`}
                >
                  <span className="text-xs text-slate-700 min-w-0 truncate">
                    <strong>Nº {s.number}</strong> · {s.school_name} · {s.items_pending} de {s.items_count} pendente{s.items_pending > 1 ? "s" : ""}
                  </span>
                  <span className="text-[11px] font-bold text-indigo-700 shrink-0 inline-flex items-center gap-0.5">
                    {s.days_stalled} dias <ChevronRight className="w-3.5 h-3.5" />
                  </span>
                </Link>
                <button onClick={() => ack(s.id)} disabled={busy === s.id}
                  className="shrink-0 inline-flex items-center gap-1 rounded-lg bg-indigo-600 text-white text-[11px] font-bold px-2.5 hover:bg-indigo-700 active:scale-95 transition-[background-color,transform] disabled:opacity-60"
                  data-testid={`nfa-stalled-ack-${s.id}`}>
                  <Check className="w-3.5 h-3.5" />Ciente
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
